<template>
  <div id="china-individual-update-page">
    <div class="item">
      <div class="item-label">
        <div class="label-title">統一社会信用番号</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.unifiedSocialCreditIdentifier" name="unifiedSocialCreditIdentifier" autocomplete="off" placeholder="数字18桁" v-validate="'required|length:18'" data-vv-as="統一社会信用番号">
        <div v-show="errors.has('unifiedSocialCreditIdentifier')" class="text-danger">※{{ errors.first('unifiedSocialCreditIdentifier') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">インボイス登録番号<br>（適格請求書発行事業者登録番号）<br>（JCT番号）</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <select class="form-control" v-model="formData.invoiceRegistrationKbn" name="invoiceRegistrationKbn" v-validate="'required'" data-vv-as="インボイス登録番号取得区分" @change="changeInvoiceRegistrationKbn()">
          <option value="">選択してください</option>
          <option
            v-for="invoiceRegistrationKbnOption in invoiceRegistrationKbnOptions"
            :value="invoiceRegistrationKbnOption.id"
            :key="`invoiceRegistrationKbn-${invoiceRegistrationKbnOption.id}`"
            >
            {{ invoiceRegistrationKbnOption.name }}
          </option>
        </select>
        <div v-show="errors.has('invoiceRegistrationKbn')" class="text-danger">※{{ errors.first('invoiceRegistrationKbn') }}</div>
        <div v-if="showInvoiceRegistrationDate">
          <div class="m-t">取得予定日</div>
          <div>
            <date-picker
              v-model="formData.invoiceRegistrationDate"
              placeholder="例) yyyy/mm/dd"
              ref="invoiceRegistrationDate"
              format="YYYY/MM/DD"
              name="invoiceRegistrationDate"
              v-validate="'required'"
              data-vv-as="取得予定日"
              :input-attr="{class: 'invoice-registration-date form-control'}"
              :lang="lang"
              :not-before="todayFormatDate"
            />
          </div>
          <div v-show="errors.has('invoiceRegistrationDate')" class="text-danger">※{{ errors.first('invoiceRegistrationDate') }}</div>
        </div>
        <div v-if="showInvoiceRegistrationNumber">
          <div class="m-t">登録番号</div>
          <input type="text" class="form-control" v-model="formData.invoiceRegistrationNumber" name="invoiceRegistrationNumber" autocomplete="off" placeholder="T + 数字13桁" v-validate="'required|length:14'" data-vv-as="登録番号">
          <div v-show="errors.has('invoiceRegistrationNumber')" class="text-danger">※{{ errors.first('invoiceRegistrationNumber') }}</div>
          <div class="input-note pd-l-10">
            インボイス登録番号を確認したい場合は、<a href="https://www.invoice-kohyo.nta.go.jp/" target="_blank" class="text--underline">こちら</a>
          </div>
        </div>
        <div class="input-description">
          ※セルモン設定画面からもご登録が可能です。
        </div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 屋号</div>
        <div class="label-any">任意</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.companyName" name="companyName" autocomplete="off" placeholder="例) セルモン" v-validate="'max:100'" data-vv-as="[担当] 屋号">
        <div v-show="errors.has('companyName')" class="text-danger">※{{ errors.first('companyName') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 屋号フリガナ、または英字</div>
        <div class="label-any">任意</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.companyNameEiji" name="companyNameEiji" autocomplete="off" placeholder="例) セルモン" v-validate="'max:200'" data-vv-as="[担当] 屋号フリガナ、または英字">
        <div v-show="errors.has('companyNameEiji')" class="text-danger">※{{ errors.first('companyNameEiji') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 担当者氏名</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.sellerName" name="sellerName" autocomplete="off" placeholder="例) セルモン 花子" v-validate="'required|max:100'" data-vv-as="[担当] 担当者氏名">
        <div v-show="errors.has('sellerName')" class="text-danger">※{{ errors.first('sellerName') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 担当者氏名フリガナ、または英字</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.sellerNameEiji" name="sellerNameEiji" autocomplete="off" placeholder="例) セルモン ハナコ" v-validate="'required|max:200'" data-vv-as="[担当] 担当者氏名フリガナ、または英字">
        <div v-show="errors.has('sellerNameEiji')" class="text-danger">※{{ errors.first('sellerNameEiji') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 郵便番号</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.zipCode" name="zipCode" autocomplete="off" placeholder="例) 1234567（ハイフンなし）" v-validate="'required|numeric|min:1|max:7'" data-vv-as="[担当] 郵便番号">
        <div v-show="errors.has('zipCode')" class="text-danger">※{{ errors.first('zipCode') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 地域</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <select class="form-control" v-model="formData.stateCode" name="stateCode" v-validate="'required'" data-vv-as="[担当] 地域">
          <option value="">選択してください</option>
          <option
            v-for="state in stateList"
            :value="state.state_code"
            :key="`cor-${state.id}`"
          >
            {{ state.state_name }}
          </option>
        </select>
        <div v-show="errors.has('stateCode')" class="text-danger">※{{ errors.first('stateCode') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 住所</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.address" name="address" autocomplete="off" placeholder="例) 東京都新宿区西新宿２丁目８−１" v-validate="'required|max:400'" data-vv-as="[担当] 住所">
        <div v-show="errors.has('address')" class="text-danger">※{{ errors.first('address') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 建物名</div>
        <div class="label-any">任意</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.addressBuilding" name="addressBuilding" autocomplete="off" placeholder="例) セルモンタワー" v-validate="'max:100'" data-vv-as="[担当] 建物名">
        <div v-show="errors.has('addressBuilding')" class="text-danger">※{{ errors.first('addressBuilding') }}</div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">
        <div class="label-title">[担当] 電話番号</div>
        <div class="label-required">必須</div>
      </div>
      <div class="item-content">
        <input type="text" class="form-control" v-model="formData.telNo" name="telNo" autocomplete="off" placeholder="例) 03-1234-5678" v-validate="'required|max:20'" data-vv-as="[担当] 電話番号">
        <div v-show="errors.has('telNo')" class="text-danger">※{{ errors.first('telNo') }}</div>
      </div>
    </div>
    <div class="mr-t-10">
      <a href="javascript:void(0)" v-html="`< 戻る`" @click.prevent="$emit('back')"></a>
    </div>
    <div class="box-step-action">
      <button type="button" class="btn btn-info btn-register" @click.prevent="handleSubmit()">登録する</button>
    </div>
  </div>
</template>

<script>
import AreaService from '@/services/areaservice'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    DatePicker
  },
  props: {
    seller: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      stateList: null,
      loader: null,
      formData: {
        unifiedSocialCreditIdentifier: this.seller.unifiedSocialCreditIdentifier,
        invoiceRegistrationNumber: this.seller.invoiceRegistrationNumber,
        invoiceRegistrationKbn: this.seller.invoiceRegistrationKbn,
        invoiceRegistrationDate: this.seller.invoiceRegistrationDate,
        companyName: this.seller.companyName,
        companyNameEiji: this.seller.companyNameEiji,
        sellerName: this.seller.sellerName,
        sellerNameEiji: this.seller.sellerNameEiji,
        zipCode: this.seller.zipCode,
        stateCode: this.seller.stateCode ? this.seller.stateCode : '',
        address: this.seller.address,
        addressBuilding: this.seller.addressBuilding,
        telNo: this.seller.telNo
      },
      invoiceRegistrationKbnOptions: [
        {
          id: 0,
          name: '取得予定なし（無申請計劃）'
        },
        {
          id: 1,
          name: '取得予定あり（有申請計劃）'
        },
        {
          id: 2,
          name: '取得済み（已經取得）'
        }
      ],
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      showInvoiceRegistrationNumber: false,
      showInvoiceRegistrationDate: false
    }
  },
  computed: {
    todayFormatDate () {
      return moment().format('YYYY/MM/DD')
    }
  },
  created () {
    this.getAllArea()
  },
  methods: {
    async handleSubmit () {
      let validated = await this.$validator.validateAll()
      if (validated) {
        this.$emit('handleSubmit', this.formData)
      }
    },
    async getAllArea () {
      this.loader = this.$loading.show()
      await AreaService.getAll()
        .then((response) => {
          const targetList = response.data.filter(data => data.country_code === this.seller.countryCode)[0]
          this.stateList = targetList.states
          this.loader && this.loader.hide()
        })
        .catch((err) => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    changeInvoiceRegistrationKbn () {
      this.displayInputsInvoiceRegistration()
    },
    displayInputsInvoiceRegistration () {
      let noPlan = 0
      let planed = 1
      let buyed = 2
      let invoiceRegistrationKbn = this.formData.invoiceRegistrationKbn ? parseInt(this.formData.invoiceRegistrationKbn) : ''
      if (invoiceRegistrationKbn === buyed) {
        this.showInvoiceRegistrationDate = false
        this.showInvoiceRegistrationNumber = true
      } else if (invoiceRegistrationKbn === planed) {
        this.showInvoiceRegistrationDate = true
        this.showInvoiceRegistrationNumber = false
      } else if (invoiceRegistrationKbn === noPlan || invoiceRegistrationKbn === '') {
        this.showInvoiceRegistrationDate = false
        this.showInvoiceRegistrationNumber = false
      }
    }
  },
  mounted () {
    this.displayInputsInvoiceRegistration()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/updateRegisterInfo/ChinaIndividual.vue